import React, {useEffect} from 'react';
import Loading from '../../common/components/Loading/Loading';

// La documentación de la API externa la sirve el backend en /api/external-docs
// (Swagger, generado desde las anotaciones de external-api.router.ts). La API
// va montada en el mismo host que el front, así que alcanza con una ruta
// relativa y no hace falta ninguna variable de entorno.
// Esta ruta existe para pasar por el PrivateRoute (ADMIN / DEVELOPER) antes
// de salir del SPA.
const EXTERNAL_DOCS_PATH = '/api/external-docs/';

const Documentation = () => {
    useEffect(() => {
        window.location.replace(EXTERNAL_DOCS_PATH);
    }, []);

    return <Loading className="ul-div-sect-table"/>;
};

export default Documentation;
